import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ToasterProps } from "vue-sonner"
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, XIcon } from "lucide-vue-next"
import { Toaster as Sonner } from "vue-sonner"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'Sonner',
  props: {
    id: {},
    invert: { type: Boolean },
    theme: {},
    position: {},
    closeButtonPosition: {},
    hotkey: {},
    richColors: { type: Boolean },
    expand: { type: Boolean },
    duration: {},
    gap: {},
    visibleToasts: {},
    closeButton: { type: Boolean },
    toastOptions: {},
    class: {},
    style: {},
    offset: {},
    mobileOffset: {},
    dir: {},
    swipeDirections: {},
    icons: {},
    containerAriaLabel: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sonner), _mergeProps({
    class: _unref(cn)('toaster group', props.class),
    style: {
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--border-radius': 'var(--radius)',
    }
  }, props), {
    "success-icon": _withCtx(() => [
      _createVNode(_unref(CircleCheckIcon), { class: "size-4" })
    ]),
    "info-icon": _withCtx(() => [
      _createVNode(_unref(InfoIcon), { class: "size-4" })
    ]),
    "warning-icon": _withCtx(() => [
      _createVNode(_unref(TriangleAlertIcon), { class: "size-4" })
    ]),
    "error-icon": _withCtx(() => [
      _createVNode(_unref(OctagonXIcon), { class: "size-4" })
    ]),
    "loading-icon": _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(Loader2Icon), { class: "size-4 animate-spin" })
      ])
    ]),
    "close-icon": _withCtx(() => [
      _createVNode(_unref(XIcon), { class: "size-4" })
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})